import { render, staticRenderFns } from "./PageCover.vue?vue&type=template&id=c28baae0&"
import script from "./PageCover.vue?vue&type=script&lang=js&"
export * from "./PageCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports